"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jquery = _interopRequireDefault(require("jquery"));

var _immutable = _interopRequireDefault(require("immutable"));

var selectors = _immutable.default.Map({
  htmlAndBody: 'html, body'
});

var _default = {
  /**
   * Scroll to a particular node on the page.
   *
   * @param {Node|String} scrollToNode - Node to scroll to
   */
  scrollTo: function scrollTo(scrollToNode) {
    (0, _jquery.default)(selectors.get('htmlAndBody')).animate({
      scrollTop: (0, _jquery.default)(scrollToNode).offset().top
    }, 1000);
  }
};
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/util/UIUtil.js
// module id = 312
// module chunks = 0